<div class="totals" [attr.aria-live]="ariaLive()" [attr.role]="role()">
    @if (data(); as productCard) {
        <div class="total-item">
            <p class="body-0">Subtotal</p>
            <div class="quantity">
                @if (productCard.subtotalDiscountedPrice) {
                    <p>
                        <span class="cta"
                            >{{ productCard.subtotalDiscountedPrice | appDigitsGrouping }} {{ rewardName() }}</span
                        >
                    </p>
                    <lib-cart-old-price [inline]="true" [price]="productCard.subtotalPrice" />
                } @else {
                    <p>
                        <span class="cta">{{ productCard.subtotalPrice | appDigitsGrouping }} {{ rewardName() }}</span>
                    </p>
                }
            </div>
        </div>
        <div class="total-item">
            <p class="body-0">Shipping</p>
            <p class="body-0">Free</p>
        </div>
        <div class="divider-line"></div>
        <div class="total-item">
            <p class="subheading-1 total">{{ totalLabel() }}</p>
            <div class="quantity">
                @if (productCard.subtotalDiscountedPrice) {
                    <p class="body-0">
                        <span class="primary-cta"
                            >{{ totalDiscountedPrice() | appDigitsGrouping }} {{ rewardName() }}</span
                        >
                    </p>
                    <lib-cart-old-price [inline]="true" [price]="totalPrice()" />
                } @else {
                    <p class="body-0">
                        <span class="primary-cta">{{ totalPrice() | appDigitsGrouping }} {{ rewardName() }}</span>
                    </p>
                }
            </div>
        </div>
    } @else {
        <ng-container *ngTemplateOutlet="skeletonService.rectangleTemplate()"></ng-container>
    }
</div>
